import { lazyNamed } from 'src/utils/lazyNamed';

export const PositionGroups = {
  List: lazyNamed(() => import('./pages/PositionGroupList'), 'PositionGroupList'),
  PositionGroupForm: lazyNamed(() => import('./pages/PositionGroupForm'), 'PositionGroupForm'),
  PositionsForm: lazyNamed(() => import('./pages/PositionsForm'), 'PositionsForm'),
};
